export default "__VITE_ASSET__Bhte2WyU__"